import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const isAuth = !!sessionStorage.getItem("token");

  return isAuth ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;